import React from "react";
import {Navigate, useParams} from "react-router-dom";
import Page from "@jumbo/shared/Page";
import TripsIndex from "app/pages/trips/TripsIndex";
import DriverWorkdays from "app/pages/trips/DriverWorkdays";
import CustomersIndex from "app/pages/customers/CustomersIndex";
import Logs from "app/pages/Logs";
import UsersIndex from "app/pages/users/UsersIndex";
import CompanySettings from "app/pages/companies/CompanySettings";
import OrdersList from "app/pages/orders/OrdersList";
import SKUList from "app/pages/skus/SKUList";
import WarehouseBoard from "app/pages/warehouse/WarehouseBoard";
import InventoryList from "app/pages/inventory/InventoryList";
import PlanificationIndex from "app/pages/planification/PlanificationIndex";
import OrdersCalendar from "app/pages/orders_calendar/OrdersCalendar";
import PluginsIndex from "app/pages/plugins/PluginsIndex";
import CentresIndex from "app/pages/centres/CentresIndex";
import VehiclesIndex from "app/pages/vehicles/VehiclesIndex";
import PrintersIndex from "app/pages/printers/PrintersIndex";
import SurveysIndex from "app/pages/surveys/SurveysIndex";
import TaskAuthorizationsIndex from "app/pages/task_authorizations/TaskAuthorizationsIndex";
import FileTasksIndex from "app/pages/file_tasks/FileTasksIndex";
import LegacyDashboardRoute from "app/pages/dashboard/LegacyDashboardRoute";
import BusinessDashboardRoute from "app/pages/business_dashboard/BusinessDashboardRoute";
import SubscriptionsIndex from "app/pages/subscriptions/SubscriptionsIndex";
import WhatsappInbox from "app/pages/whatsapp/WhatsappInbox";
import BugReportsIndex from "app/pages/bug_reports/BugReportsIndex";
import ReleaseNotesIndex from "app/pages/release_notes/ReleaseNotesIndex";
import NovedadesPage from "app/pages/release_notes/NovedadesPage";
import TripLabelsPage from "app/pages/labels/TripLabelsPage";
import PulseIndex from "app/pages/pulse/PulseIndex";
import AttendanceIndex from "app/pages/attendance/AttendanceIndex";
import DevicesIndex from "app/pages/devices/DevicesIndex";
import IntegrationStatusIndex from "app/pages/integration_status/IntegrationStatusIndex";
import RelbaseConfig from "app/pages/plugins/RelbaseConfig";
import DocumentsIndex from "app/pages/documents/DocumentsIndex";
import ClientPortal from "app/pages/client_portal/ClientPortal";
import HomeRedirect from "app/pages/client_portal/HomeRedirect";

// La configuracion de Relbase vivio en Estado de integraciones; ahora cuelga de Plugins.
// Los links viejos siguen llevando a la misma pantalla.
const RelbaseConfigMoved = () => {
    const { id } = useParams();
    return <Navigate to={`/plugins/relbase/${id}`} replace />;
};

const mainRoutes = [
    {
        path: "/",
        element: <HomeRedirect />
    },
    {
        path: "/mis-pedidos",
        element: <Page component={ClientPortal} />
    },
    {
        path: "/company_settings",
        element: <Page component={CompanySettings} />
    },
    {
        path: "/customers",
        element: <Page component={CustomersIndex} />
    },
    {
        path: "/task_authorizations",
        element: <Page component={TaskAuthorizationsIndex} />
    },
    {
        path: "/logs",
        element: <Page component={Logs} />
    },
    {
        path: "/orders",
        element: <Page component={OrdersList} />
    },
    {
        path: "/documents",
        element: <Page component={DocumentsIndex} />
    },
    {
        path: "/skus",
        element: <Page component={SKUList} />
    },
    {
        path: "/warehouse",
        element: <Page component={WarehouseBoard} />
    },
    {
        path: "/inventory",
        element: <Page component={InventoryList} />
    },
    {
        path: "/planification",
        element: <Page component={PlanificationIndex} />
    },
    {
        path: "/orders_calendar",
        element: <Page component={OrdersCalendar} />
    },
    {
        path: "/plugins",
        element: <Page component={PluginsIndex} />
    },
    {
        path: "/plugins/relbase/:id",
        element: <Page component={RelbaseConfig} />
    },
    {
        path: "/centres",
        element: <Page component={CentresIndex} />
    },
    {
        path: "/trips",
        element: <Page component={TripsIndex} />
    },
    {
        path: "/trips/jornada",
        element: <Page component={DriverWorkdays} />
    },
    {
        path: "/users",
        element: <Page component={UsersIndex} />
    },
    {
        path: "/dashboard",
        element: <Page component={LegacyDashboardRoute} />
    },
    {
        path: "/business-dashboard",
        element: <Page component={BusinessDashboardRoute} />
    },
    {
        path: "/vehicles",
        element: <Page component={VehiclesIndex} />
    },
    {
        path: "/printers",
        element: <Page component={PrintersIndex} />
    },
    {
        path: "/surveys",
        element: <Page component={SurveysIndex} />
    },
    {
        path: "/file_tasks",
        element: <Page component={FileTasksIndex} />
    },
    {
        path: "/subscriptions",
        element: <Page component={SubscriptionsIndex} />
    },
    {
        path: "/whatsapp",
        element: <Page component={WhatsappInbox} />
    },
    {
        path: "/bug_reports",
        element: <Page component={BugReportsIndex} />
    },
    {
        path: "/release_notes",
        element: <Page component={ReleaseNotesIndex} />
    },
    {
        path: "/novedades",
        element: <Page component={NovedadesPage} />
    },
    {
        path: "/etiquetas",
        element: <Page component={TripLabelsPage} />
    },
    {
        path: "/pulso",
        element: <Page component={PulseIndex} />
    },
    {
        path: "/asistencia",
        element: <Page component={AttendanceIndex} />
    },
    {
        path: "/dispositivos",
        element: <Page component={DevicesIndex} />
    },
    {
        path: "/estado_integraciones",
        element: <Page component={IntegrationStatusIndex} />
    },
    {
        path: "/estado_integraciones/relbase/:id",
        element: <RelbaseConfigMoved />
    },
];

export default mainRoutes;
